import { Component } from '@angular/core';

@Component({
    selector: 'app-college-admin',
    templateUrl: './college-admin.component.html',
    standalone: false
})
export class CollegeAdminComponent {

}
